import { render, staticRenderFns } from "./DriverAccount.vue?vue&type=template&id=645cfc16&scoped=true&"
import script from "./DriverAccount.vue?vue&type=script&lang=js&"
export * from "./DriverAccount.vue?vue&type=script&lang=js&"
import style0 from "./DriverAccount.vue?vue&type=style&index=0&id=645cfc16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645cfc16",
  null
  
)

export default component.exports